document.addEventListener("DOMContentLoaded", () => {
  const timers = document.querySelectorAll(".top-bar__timer");
  if (!timers.length) return;

  // Парсим "YYYY-MM-DDTHH:mm" (или c :ss) как локальные часы заданной TZ и переводим в настоящий UTC timestamp
  function zonedEndToUTC(endStr, timeZone) {
    const m = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?$/.exec((endStr || "").trim());
    if (!m) return null;
    const [_, y, mo, d, h, mi, s] = m;
    const year   = +y;
    const month  = +mo;
    const day    = +d;
    const hour   = +h;
    const minute = +mi;
    const second = +(s || 0);

    // Притворяемся, что это уже UTC-компоненты:
    const pretendUTC = Date.UTC(year, month - 1, day, hour, minute, second);

    // Узнаём смещение таймзоны в этот момент:
    const offsetMs = getTimeZoneOffsetForUTC(new Date(pretendUTC), timeZone);
    // Реальный UTC = «локальные стены» минус смещение
    return pretendUTC - offsetMs;
  }

  // Смещение TZ (миллисекунды) для данного UTC времени
  function getTimeZoneOffsetForUTC(utcDate, timeZone) {
    const dtf = new Intl.DateTimeFormat('en-GB', {
      timeZone,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false
    });
    const parts = dtf.formatToParts(utcDate).reduce((acc, p) => { acc[p.type] = p.value; return acc; }, {});
    const asUTC = Date.UTC(
      +parts.year, (+parts.month) - 1, +parts.day,
      +parts.hour, +parts.minute, +parts.second
    );
    // Положительное значение означает TZ = UTC+X
    return asUTC - utcDate.getTime();
  }

  function pad2(n) { return String(n).padStart(2, "0"); }

  function render(el, totalSec) {
    const daysEl    = el.querySelector("#topbar-days");
    const hoursEl   = el.querySelector("#topbar-hours");
    const minutesEl = el.querySelector("#topbar-minutes");
    const secondsEl = el.querySelector("#topbar-seconds");
    const daysLabel = el.querySelector("#topbar-days-label");

    const d = Math.max(0, Math.floor(totalSec / 86400));
    const h = Math.max(0, Math.floor((totalSec % 86400) / 3600));
    const m = Math.max(0, Math.floor((totalSec % 3600) / 60));
    const s = Math.max(0, Math.floor(totalSec % 60));

    if (daysEl)    daysEl.textContent    = pad2(d);
    if (hoursEl)   hoursEl.textContent   = pad2(h);
    if (minutesEl) minutesEl.textContent = pad2(m);
    if (secondsEl) secondsEl.textContent = pad2(s);

    if (daysLabel) {
      const singular = daysLabel.dataset.singular || "Tag";
      const plural   = daysLabel.dataset.plural   || "Tage";
      daysLabel.textContent = (d === 1) ? singular : plural;
    }
  }

  const configs = [];
  timers.forEach((el) => {
    const endStr        = el.getAttribute("data-end") || "";
    const tz            = (el.getAttribute("data-timezone") || "Europe/Berlin").trim();
    const hideWhenEnded = (el.getAttribute("data-hide-when-ended") || "true") === "true";

    const endUTC = zonedEndToUTC(endStr, tz);
    if (!endUTC) return; // нет корректной даты — не инициализируем

    configs.push({ el, endUTC, hideWhenEnded });
  });

  if (!configs.length) return;

  function tick() {
    const nowUTC = Date.now();

    configs.forEach(({ el, endUTC, hideWhenEnded }) => {
      const diffMs = endUTC - nowUTC;
      if (diffMs <= 0) {
        render(el, 0);
        if (hideWhenEnded) el.style.display = "none";
        return;
      }
      render(el, Math.floor(diffMs / 1000));
    });
  }

  tick();
  const interval = setInterval(tick, 1000);

  const obs = new MutationObserver(() => {
    const anyVisible = Array.from(timers).some(t => t.style.display !== "none");
    if (!anyVisible) {
      clearInterval(interval);
      obs.disconnect();
    }
  });
  obs.observe(document.body, { attributes: true, subtree: true, attributeFilter: ["style"] });
});
